import 'bootstrap';
import 'axios';
import Echo from "laravel-echo";
import Pusher from "pusher-js";

window.axios = axios;
window.Pusher = Pusher;

const token =
  window.localStorage.getItem("token") ||
  window.localStorage.getItem("access_token");

window.Echo = new Echo({
  broadcaster: "pusher",
  key: process.env.MIX_PUSHER_APP_KEY,
  wsHost: process.env.MIX_PUSHER_HOST || window.location.hostname,
  wsPort: Number(process.env.MIX_PUSHER_PORT || 6001),
  wssPort: Number(process.env.MIX_PUSHER_PORT || 6001),
  forceTLS: (process.env.MIX_PUSHER_SCHEME || "http") === "https",
  disableStats: true,
  enabledTransports: ["ws", "wss"],

  authEndpoint: "/api/broadcasting/auth",

  auth: {
    headers: {
      Authorization: token ? `Bearer ${token}` : "",
      Accept: "application/json",
    },
  },
});